<template>
  <section class="table-events">
    <div class="table-events__column-static">
      <div class="table-events__column-static__col-item">
        <div class="movil-shield-hidden">Partido</div>
        <div class="movil-team-view">Equipo</div>
      </div>
      <div
        v-for="(event, index) of tableData"
        :key="`t${index}`"
        class="table-events__column-static__col-item"
        :class="
          index === 0
            ? ['border-top-right', 'border-top-left']
            : index === tableData.length - 1
            ? ['border-bottom-right', 'border-bottom-left']
            : ''
        "
      >
        <div>
          <img :src="event.homeTeamLogo" />
        </div>
        <div class="movil-shield-hidden">VS</div>
        <div class="movil-shield-hidden">
          <img :src="event.awayTeamLogo" />
        </div>
      </div>
    </div>
    <div class="table-events__column-scroll">
      <div class="table-events__column-scroll__wrapper">
        <div class="table-events__column-scroll__wrapper__row-header">
          <div class="table-events__column-scroll__wrapper__row-header__col border-top-left border-bottom-left">
            Equipo
          </div>
          <!-- <div class="table-events__column-scroll__wrapper__row-header__col">Jugador</div> -->
          <div class="table-events__column-scroll__wrapper__row-header__col">
            <div class="table-events__column-scroll__wrapper__row-header__col__text-full-two">
              1er / 2do<br />
              Tiempo
            </div>
          </div>
          <div class="table-events__column-scroll__wrapper__row-header__col">
            <div class="table-events__column-scroll__wrapper__row-header__col__text-full-two">
              Minuto<br />
              Inicial
            </div>
          </div>
          <div class="table-events__column-scroll__wrapper__row-header__col">
            <div class="table-events__column-scroll__wrapper__row-header__col__text-full-two">
              Minuto<br />
              Final
            </div>
          </div>
          <div class="table-events__column-scroll__wrapper__row-header__col">
            <div class="table-events__column-scroll__wrapper__row-header__col__text">Duración</div>
            <div class="table-events__column-scroll__wrapper__row-header__col__text-leyend leyend">(Segundos)</div>
          </div>
          <div class="table-events__column-scroll__wrapper__row-header__col">
            <div class="table-events__column-scroll__wrapper__row-header__col__text-full-two">
              Marcador al<br />
              momento
            </div>
          </div>
          <!-- <div class="table-events__column-scroll__wrapper__row-header__col border-top-right border-bottom-right">
            Comentarios
          </div> -->
        </div>
        <div
          v-for="(event, index) of tableData"
          :key="`ei${index}`"
          class="table-events__column-scroll__wrapper__row-items"
        >
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray border-top-left team-name">
            {{ event.teamName }}
          </div>
          <!-- <div class="table-events__column-scroll__wrapper__row-items__col color-gray player-column">
            {{ event.playerName }}
          </div> -->
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray">
            {{ event.matchLapse }}
          </div>
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray">
            {{ event.start }}
          </div>
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray">
            {{ event.end }}
          </div>
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray">
            {{ event.duration }}
          </div>
          <div class="table-events__column-scroll__wrapper__row-items__col color-gray">
            {{ event.score }}
          </div>
          <!-- <div class="table-events__column-scroll__wrapper__row-items__col color-gray border-top-right">
            {{ event.comments }}
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TableEvents',
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.team-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.player-column {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.border-top-right {
  border-top-right-radius: 4px;
}
.border-bottom-right {
  border-bottom-right-radius: 4px;
}
.border-top-left {
  border-top-left-radius: 4px;
}
.border-bottom-left {
  border-bottom-left-radius: 4px;
}
.movil-shield-hidden {
  // @media screen and (max-width: 1320px) {
  //   display: none;
  // }
}
.movil-team-view {
  display: none;
  // @media screen and (max-width: 1320px) {
  //   display: inline-block;
  // }
}
.leyend {
  font-family: 'Avenir-Regular';
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.26px;
  @media screen and (max-width: 1320px) {
    font-size: 13px;
  }
  @media screen and (max-width: 980px) {
    font-size: 12px;
  }
  @media screen and (max-width: 870px) {
    font-size: 11px;
  }
}
// .border-top-left-right {
//   border-top-left-radius: 4px;
//   border-top-right-radius: 4px;
// }
// .border-bottom-left-right {
//   border-bottom-left-radius: 4px;
//   border-bottom-right-radius: 4px;
// }
// .text-pc {
//   @media screen and (max-width: 500px) {
//     display: none;
//   }
// }
// .text-movil {
//   display: none;
//   @media screen and (max-width: 500px) {
//     display: inline-block;
//   }
// }
// .row-margin {
//   margin-bottom: 2px;
// }
.color-gray {
  background: #f8fafc !important;
}
.color-white {
  background: #ffffff !important;
}
.table-events {
  width: 98.44%;
  margin-top: 9px;
  height: 210px;
  display: inline-flex;
  justify-content: center;
  overflow: auto;
  &__column-static {
    width: 12.9%;
    height: auto;

    @media screen and (max-width: 1320px) {
      width: 34.6%;
    }
    @media screen and (max-width: 758px) {
      width: 28%;
    }
    // @media screen and (max-width: 680px) {
    //   width: 13%;
    // }
    // @media screen and (max-width: 500px) {
    //   width: 16%;
    //   margin-left: 1%;
    // }
    // @media screen and (max-width: 400px) {
    //   width: 20%;
    //   margin-left: 1%;
    // }
    // background: red;
    &__col-item:first-child {
      width: 100%;
      height: 48px;
      border-radius: 4px;
      background-color: #132739;
      font-size: 13px;
      border-right: solid 1px #132739;
      border-left: solid 1px #132739;
      font-weight: normal;
      font-stretch: normal;
      margin-bottom: 2px;
      font-style: normal;
      line-height: 48px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
      @media screen and (max-width: 1320px) {
        font-size: 13px;
      }
      @media screen and (max-width: 980px) {
        font-size: 12px;
      }
      @media screen and (max-width: 870px) {
        font-size: 11px;
      }
      @media screen and (max-width: 758px) {
        font-size: 13px;
      }
    }
    &__col-item {
      width: 100%;
      height: 39px;
      background-color: #132739;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      border: solid 1px #224361 !important;
      font-style: normal;
      line-height: 39px;
      letter-spacing: -0.26px;
      text-align: center;
      font-family: 'Avenir-Demi';
      color: #fff;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      img {
        width: 20px;
        margin-top: 12px;
        margin-left: 10px;
        margin-right: 10px;
        @media screen and (max-width: 380px) {
          width: 17px;
          margin-left: 8px;
        }
      }
    }
  }
  //AQUI
  &__column-scroll {
    width: 86.85%;
    height: auto;
    margin-left: 0.28%;
    // overflow-x: auto;
    // overflow-y: hidden;
    @media screen and (max-width: 1320px) {
      width: 90.85%;
    }
    @media screen and (max-width: 758px) {
      width: 72%;
    }

    @media screen and (max-width: 500px) {
      margin-left: 1%;
    }
    @media screen and (max-width: 400px) {
      margin-left: 1%;
    }
    &__wrapper {
      width: 100%;
      height: auto;
      @media screen and (max-width: 758px) {
        width: 1080px;
      }
      @media screen and (max-width: 500px) {
        width: 980px;
      }
      @media screen and (max-width: 400px) {
        width: 720px;
      }
      &__row-header {
        width: 100%;
        height: 48px;
        display: inline-flex;
        margin-bottom: 2px;
        &__col:nth-child(1) {
          width: 19.09%;
          height: 48px;
          background-color: #52a0fc;
          border-right: solid 1px #ffffff;
          border-left: solid 1px #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 48px;
          letter-spacing: -0.28px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 1320px) {
            font-size: 13px;
            // display: none;
          }
          @media screen and (max-width: 980px) {
            font-size: 12px;
          }
          @media screen and (max-width: 870px) {
            font-size: 11px;
          }
          @media screen and (max-width: 758px) {
            font-size: 14px;
          }
        }
        &__col:nth-child(2) {
          width: 15.13%;
          height: 48px;
          background-color: #52a0fc;
          border-right: solid 1px #ffffff;
          border-left: solid 1px #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 48px;
          letter-spacing: -0.28px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 1320px) {
            font-size: 13px;
          }
          @media screen and (max-width: 980px) {
            font-size: 12px;
          }
          @media screen and (max-width: 870px) {
            font-size: 11px;
          }
          @media screen and (max-width: 758px) {
            font-size: 14px;
          }
        }
        &__col:nth-child(3),
        &__col:nth-child(4),
        &__col:nth-child(5),
        &__col:nth-child(6),
        &__col:nth-child(7) {
          width: 16.48%;
          height: 48px;
          background-color: #52a0fc;
          border-right: solid 1px #ffffff;
          border-left: solid 1px #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 16px;
          padding-top: 8px;
          letter-spacing: -0.28px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 1320px) {
            font-size: 13px;
          }
          @media screen and (max-width: 980px) {
            font-size: 12px;
          }
          @media screen and (max-width: 870px) {
            font-size: 11px;
          }
          @media screen and (max-width: 758px) {
            font-size: 14px;
          }
          // @media screen and (max-width: 1320px) {
          //   width: 11.2%;
          // }
        }
        &__col:nth-child(7) {
          // @media screen and (max-width: 1320px) {
          //   width: 12.18%;
          // }
        }
        &__col:nth-child(8) {
          width: 27.9%;
          height: 48px;
          background-color: #52a0fc;
          border-right: solid 1px #ffffff;
          border-left: solid 1px #ffffff;
          font-family: 'Avenir-Demi';
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 48px;
          letter-spacing: -0.28px;
          text-align: center;
          color: #fff;
          @media screen and (max-width: 1320px) {
            font-size: 13px;
          }
          @media screen and (max-width: 980px) {
            font-size: 12px;
          }
          @media screen and (max-width: 870px) {
            font-size: 11px;
          }
          @media screen and (max-width: 758px) {
            font-size: 14px;
          }
        }
      }
      &__row-items {
        width: 100%;
        height: 39px;
        display: inline-flex;
        &__col {
          border: solid 1px #ecedef;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 40px;
          font-family: 'Avenir-Bold';
          letter-spacing: -0.28px;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 1320px) {
            font-size: 13px;
          }
          @media screen and (max-width: 980px) {
            font-size: 12px;
          }
          @media screen and (max-width: 870px) {
            font-size: 11px;
          }
          @media screen and (max-width: 758px) {
            font-size: 14px;
          }
          @media screen and (max-width: 500px) {
            font-size: 13px;
          }
        }
        &__col:nth-child(1) {
          width: 19.09%;
          height: 39px;
          // @media screen and (max-width: 1320px) {
          //   display: none;
          // }
        }
        &__col:nth-child(2) {
          width: 15.13%;
          height: 39px;
        }
        &__col:nth-child(3),
        &__col:nth-child(4),
        &__col:nth-child(5),
        &__col:nth-child(6),
        &__col:nth-child(7) {
          width: 16.48%;
          height: 39px;
          // @media screen and (max-width: 1320px) {
          //   width: 11.2%;
          // }
        }
        &__col:nth-child(7) {
          // @media screen and (max-width: 1320px) {
          //   width: 12.18%;
          // }
        }
        &__col:nth-child(8) {
          width: 27.9%;
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
